import { brand } from '@/lib/brand'

type Props = {
  size?: number
  color?: string
  orange?: string
  large?: boolean
  animated?: boolean
}

export function MetkaWordmark({
  size = 24,
  color = brand.color.ink,
  orange = brand.color.accent,
  large = false,
  animated = false,
}: Props) {
  const topSize = large ? 56 : size
  const botSize = Math.round(topSize * 0.4)
  const width = Math.round(topSize * 5)
  const font = "var(--font-unbounded), var(--font-manrope), sans-serif"
  const gap = topSize * 0.22
  const arrowH = botSize * 0.55
  const totalH = topSize * 1.1 + gap + botSize * 1.1 + arrowH

  const padY = Math.round(topSize * 0.25)
  const padX = Math.round(topSize * 0.31)

  const cornerSize = Math.max(16, Math.round(topSize * 0.44))
  const cornerStroke = Math.max(3, Math.round(topSize * 0.055))
  const cornerOffsetT = Math.round(topSize * 0.14)
  const cornerOffsetX = Math.round(topSize * 0.25)

  const cornerPathLen = (cornerSize - cornerStroke) * 2
  const strokeAnim1: React.CSSProperties = animated
    ? {
        strokeDasharray: cornerPathLen,
        strokeDashoffset: cornerPathLen,
        animation: "logo-stroke-draw 1800ms cubic-bezier(0.22, 1, 0.36, 1) 250ms both",
      }
    : {}
  const strokeAnim2: React.CSSProperties = animated
    ? {
        strokeDasharray: cornerPathLen,
        strokeDashoffset: cornerPathLen,
        animation: "logo-stroke-draw 1800ms cubic-bezier(0.22, 1, 0.36, 1) 500ms both",
      }
    : {}

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        padding: `${padY}px ${padX}px`,
        lineHeight: 1,
        userSelect: 'none',
      }}
    >
      <div style={{ display: 'inline-block', lineHeight: 1 }}>
        <svg
          viewBox={`0 0 ${width} ${totalH}`}
          width={width}
          style={{ display: 'block', overflow: 'visible' }}
        >
          <text
            x="0"
            y={topSize * 0.92}
            fontFamily={font}
            fontWeight="800"
            fontSize={topSize}
            fill={color}
            textLength={width}
            lengthAdjust="spacing"
          >
            МЕТКА
          </text>
          <text
            x="0"
            y={topSize * 1.02 + gap + botSize * 0.85}
            fontFamily={font}
            fontWeight="700"
            fontSize={botSize}
            fill={color}
            textLength={width}
            lengthAdjust="spacing"
          >
            маркировочная
          </text>
        </svg>
      </div>
      <svg
        width={cornerSize}
        height={cornerSize}
        viewBox={`0 0 ${cornerSize} ${cornerSize}`}
        style={{
          position: 'absolute',
          top: -cornerOffsetT,
          right: -cornerOffsetX,
          pointerEvents: 'none',
        }}
      >
        <path
          d={`M 0 ${cornerStroke} H ${cornerSize - cornerStroke} V ${cornerSize}`}
          stroke={orange}
          strokeWidth={cornerStroke}
          fill="none"
          style={strokeAnim1}
        />
      </svg>
      <svg
        width={cornerSize}
        height={cornerSize}
        viewBox={`0 0 ${cornerSize} ${cornerSize}`}
        style={{
          position: 'absolute',
          bottom: -cornerOffsetT,
          left: -cornerOffsetX,
          pointerEvents: 'none',
        }}
      >
        <path
          d={`M 0 0 V ${cornerSize - cornerStroke} H ${cornerSize}`}
          stroke={orange}
          strokeWidth={cornerStroke}
          fill="none"
          style={strokeAnim2}
        />
      </svg>
    </div>
  )
}
